// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fi-a";
export var fulfillmentFormRail = "_fi-9";
export var headerTitleRow = "_fi-c";
export var orderDetailsWrapper = "_fi-7";
export var orderLinkTrigger = "_fi-2";
export var paymentInformationGrid = "_fi-h";
export var paymentSummaryColumn = "_fi-i";
export var shipmentContainer = "_fi-b";
export var shipmentDetailsMainPane = "_fi-8";
export var shipmentNavigationCard = "_fi-5";
export var shipmentNavigationRail = "_fi-3";
export var shipmentNavigationRailHeader = "_fi-4";
export var shipmentSummaryFact = "_fi-e";
export var shipmentSummaryGrid = "_fi-d";
export var shipmentSummaryMetadataRow = "_fi-f";
export var shipmentSummaryTags = "_fi-g";
export var shipmentWorkspace = "_fi-0";
export var shipmentWorkspaceContent = "_fi-6";
export var shipmentWorkspaceHeader = "_fi-1";